import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PageBlock from '@sharedCR/common/PageBlock';
import StatusIconCDS from 'app/shared/componentsRestyled/coreDesignSystem/StatusIconCDS';
import PropTypes from 'prop-types';

import { StatusEnum } from 'constants/status';

import { formatRawValue } from '../../formReview.utils';
import { FORM_REVIEW_LABELS, FormReviewTestIds } from '../../FormReviewCard.constants';
import {
  sectionGridStyles,
  unmappedFieldRowStyles,
  unmappedNoteStyles,
} from '../FormReviewSurface.styles';

const FormReviewUnmappedSection = ({ fields }) => {
  if (!fields || fields.length === 0) {
    return null;
  }

  return (
    <PageBlock title={FORM_REVIEW_LABELS.UNMAPPED_SECTION_TITLE}>
      <Box data-testid={FormReviewTestIds.UNMAPPED_SECTION} sx={sectionGridStyles}>
        {fields.map(field => (
          <Box
            data-testid={FormReviewTestIds.UNMAPPED_FIELD_ROW}
            key={field.fieldKey}
            sx={unmappedFieldRowStyles}
          >
            <Typography color="text.secondary" variant="bold12">
              {field.fieldKey}
            </Typography>
            <Typography variant="regular14">{formatRawValue(field.value, null)}</Typography>
            <Box sx={unmappedNoteStyles}>
              <StatusIconCDS size={16} type={StatusEnum.WARNING} />
              <Typography color="warning.dark" variant="regular12">
                {FORM_REVIEW_LABELS.UNMAPPED_FIELD_NOTE}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </PageBlock>
  );
};

FormReviewUnmappedSection.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      fieldKey: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
};

export default memo(FormReviewUnmappedSection);
